module.exports = __webpack_public_path__ + "img/halteres.e1772d9b.png";